(function () {
  'use strict';

  // ─── CONFIG ───────────────────────────────────────────────────────────────
  var NUDGE_DELAY_MS = 2000;
  var ONLY_HOMEPAGE  = true;
  // ──────────────────────────────────────────────────────────────────────────

  // ── Debug logger (disabled) ───────────────────────────────────────────────
  function log() {}

  log('Script loaded on page:', window.location.pathname);
  log('ONLY_HOMEPAGE:', ONLY_HOMEPAGE, '| NUDGE_DELAY_MS:', NUDGE_DELAY_MS);

  // ── Session storage keys ──────────────────────────────────────────────────
  //  cn_first_add    → set the moment user adds to cart in this session.
  //                    While it exists → nudge must NOT show (active shopper).
  //
  //  cn_nudge_closed → set when user explicitly closes the nudge.
  //                    While it exists → nudge must NOT show again this session.
  var KEY_FIRST_ADD    = 'cn_first_add';
  var KEY_NUDGE_CLOSED = 'cn_nudge_closed';

  function dumpSessionState(label) {
    try {
      var firstAdd    = sessionStorage.getItem(KEY_FIRST_ADD);
      var nudgeClosed = sessionStorage.getItem(KEY_NUDGE_CLOSED);
      log('[SessionState]', label || '',
        '| cn_first_add =', firstAdd === null ? 'NOT SET' : '"' + firstAdd + '"',
        '| cn_nudge_closed =', nudgeClosed === null ? 'NOT SET' : '"' + nudgeClosed + '"'
      );
    } catch(e) { log('[SessionState] ERROR reading sessionStorage:', e); }
  }

  function markFirstAdd() {
    try {
      var already = sessionStorage.getItem(KEY_FIRST_ADD);
      sessionStorage.setItem(KEY_FIRST_ADD, '1');
      log('markFirstAdd() called →', already ? 'was already set' : 'NEWLY SET');
      dumpSessionState('after markFirstAdd');
    } catch(e) { log('markFirstAdd() ERROR:', e); }
  }

  function markNudgeClosed() {
    try {
      sessionStorage.setItem(KEY_NUDGE_CLOSED, '1');
      log('markNudgeClosed() called → cn_nudge_closed SET');
      dumpSessionState('after markNudgeClosed');
    } catch(e) { log('markNudgeClosed() ERROR:', e); }
  }

  // Returns true only when BOTH keys are absent → returning visitor with cart.
  function shouldShowNudge() {
    try {
      var firstAdd    = sessionStorage.getItem(KEY_FIRST_ADD);
      var nudgeClosed = sessionStorage.getItem(KEY_NUDGE_CLOSED);
      var result      = !firstAdd && !nudgeClosed;
      log('shouldShowNudge() check:',
        'cn_first_add =', firstAdd === null ? 'NOT SET' : '"' + firstAdd + '"',
        '| cn_nudge_closed =', nudgeClosed === null ? 'NOT SET' : '"' + nudgeClosed + '"',
        '→ result:', result
      );
      if (!result) {
        if (firstAdd)    log('  ↳ BLOCKED: cn_first_add is set (user added to cart this session)');
        if (nudgeClosed) log('  ↳ BLOCKED: cn_nudge_closed is set (user already dismissed nudge)');
      }
      return result;
    } catch(e) { log('shouldShowNudge() ERROR:', e); return false; }
  }

  // ── Dump sessionStorage state on script start ─────────────────────────────
  dumpSessionState('on script load');

  // ─────────────────────────────────────────────────────────────────────────
  // IMPORTANT: interceptCartAdd() + add-event listeners MUST run on ALL pages,
  // not just the homepage. Otherwise, adding to cart on a product page will
  // never set cn_first_add, and the nudge will incorrectly fire when the user
  // navigates back to the homepage in the same session.
  // ─────────────────────────────────────────────────────────────────────────

  // ── Listen for cart changes (add-event portion – all pages) ──────────────
  function listenForAddEventsGlobal() {
    var addEvents = [
      'cart-drawer:item-added', 'cartDrawer:itemAdded', 'product:added-to-cart'
    ];
    addEvents.forEach(function (evt) {
      document.addEventListener(evt, function () {
        log('DOM event fired:', evt, '→ calling markFirstAdd()');
        markFirstAdd();
        if (overlayRef) {
          log('  ↳ nudge was open → dismissing (user is actively shopping)');
          dismiss();
        }
      });
    });
    log('Global add-event listeners registered for:', addEvents.join(', '));
  }

  // Intercept fetch + XHR to /cart/add.js → mark first_add immediately.
  // Runs on ALL pages so that a product-page add is always captured.
  function interceptCartAdd() {
    var _fetch = window.fetch;
    window.fetch = function () {
      var args = Array.prototype.slice.call(arguments);
      var url  = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      return _fetch.apply(window, args).then(function (response) {
        if (url && url.indexOf('/cart/add') !== -1) {
          log('fetch intercepted: /cart/add detected (url="' + url + '") → calling markFirstAdd()');
          markFirstAdd();
          if (overlayRef) {
            log('  ↳ nudge was open → dismissing (user is actively shopping)');
            dismiss();
          }
        }
        return response;
      });
    };

    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (_method, url) {
      this._cnUrl = url;
      return _open.apply(this, arguments);
    };
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this._cnUrl && this._cnUrl.indexOf('/cart/add') !== -1) {
        log('XHR intercepted: /cart/add detected (url="' + this._cnUrl + '")');
        this.addEventListener('load', function () {
          log('XHR /cart/add completed → calling markFirstAdd()');
          markFirstAdd();
          if (overlayRef) {
            log('  ↳ nudge was open → dismissing (user is actively shopping)');
            dismiss();
          }
        });
      }
      return _send.apply(this, arguments);
    };

    log('fetch + XHR /cart/add interceptors installed (all pages)');
  }

  // ── State ─────────────────────────────────────────────────────────────────
  var overlayRef = null;
  var isExpanded = false;

  // Install interceptors on all pages before any early-return
  listenForAddEventsGlobal();
  interceptCartAdd();

  // ── Homepage & Product page guard ────────────────────────────────────────
  if (ONLY_HOMEPAGE) {
    var path = window.location.pathname;
    log('ONLY_HOMEPAGE=true → checking path:', path);
    var isHome = (path === '/' || path === '');
    var isProduct = path.indexOf('/products/') !== -1;
    if (!isHome && !isProduct) {
      log('Not homepage or product page → exiting (nudge display disabled on this page, but add-interceptors are active)');
      return;
    }
    log('Homepage or product page confirmed → proceeding to nudge display logic');
  }

  // ── Money formatter ───────────────────────────────────────────────────────
  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // ── SVG icons ─────────────────────────────────────────────────────────────
  /* svgEdit and svgDelete commented out — edit/delete buttons removed from cart nudge.
  function svgEdit() {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"><g clip-path="url(#clip0_423_204)"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.076 3.29707C12.7106 2.93764 13.4621 2.84505 14.165 3.03965C14.4767 3.12594 14.743 3.27625 14.994 3.44603C15.2324 3.60727 15.5058 3.82074 15.8228 4.06816L15.869 4.10426C16.186 4.35167 16.4595 4.56515 16.6738 4.75729C16.8994 4.95959 17.1099 5.18144 17.2693 5.46283C17.6287 6.09746 17.7213 6.84889 17.5267 7.55179C17.4404 7.86344 17.2901 8.12976 17.1203 8.38078C16.9591 8.6192 16.7456 8.89269 16.4981 9.20966L9.98731 17.5507C9.97081 17.5718 9.95458 17.5926 9.93854 17.6132C9.63292 18.0051 9.40183 18.3013 9.11574 18.5447C8.87361 18.7507 8.60572 18.9243 8.31881 19.0612C7.97985 19.2229 7.615 19.3128 7.13238 19.4318C7.10708 19.438 7.08145 19.4443 7.05549 19.4508L5.10774 19.9315C4.97286 19.9649 4.81888 20.003 4.68306 20.0239C4.53165 20.0471 4.29718 20.0682 4.03822 19.9854C3.72692 19.8856 3.46131 19.6783 3.28903 19.4005C3.14572 19.1694 3.10925 18.9369 3.09507 18.7843C3.08235 18.6475 3.0819 18.4889 3.08151 18.3499C3.08148 18.3413 3.08146 18.3328 3.08143 18.3244L3.07514 16.3437C3.07504 16.3169 3.07495 16.2905 3.07486 16.2645C3.07307 15.7675 3.07173 15.3917 3.14631 15.0236C3.20945 14.712 3.31284 14.41 3.45387 14.1252C3.62048 13.7886 3.85182 13.4925 4.15782 13.1008C4.17386 13.0803 4.19011 13.0595 4.20658 13.0384L10.7174 4.69732C10.9648 4.38035 11.1783 4.10684 11.3705 3.89253C11.5728 3.6669 11.7946 3.45643 12.076 3.29707ZM13.6758 4.80652C13.4415 4.74165 13.1911 4.77252 12.9795 4.89232C12.9436 4.91267 12.8754 4.96041 12.7356 5.11638C12.5902 5.2785 12.4151 5.50194 12.1446 5.8485L15.0349 8.10466C15.3055 7.7581 15.4797 7.53405 15.6017 7.35369C15.7191 7.18017 15.7488 7.10241 15.7598 7.06262C15.8247 6.82832 15.7938 6.57785 15.674 6.3663C15.6537 6.33037 15.6059 6.26218 15.45 6.12233C15.2878 5.97697 15.0644 5.80193 14.7179 5.53141C14.3713 5.26088 14.1472 5.08662 13.9669 4.96464C13.7934 4.84728 13.7156 4.81753 13.6758 4.80652ZM13.9069 9.54983L11.0165 7.29368L5.65176 14.1664C5.27614 14.6476 5.17022 14.7904 5.0969 14.9386C5.02639 15.081 4.97469 15.232 4.94313 15.3877C4.9103 15.5497 4.90652 15.7274 4.90846 16.3378L4.91403 18.0911L6.61608 17.6709C7.20872 17.5246 7.38021 17.4777 7.52937 17.4065C7.67282 17.3381 7.80677 17.2513 7.92784 17.1483C8.05372 17.0412 8.1665 16.9038 8.54211 16.4226L13.9069 9.54983ZM10.9999 19.25C10.9999 18.7437 11.4103 18.3333 11.9166 18.3333H18.3333C18.8396 18.3333 19.2499 18.7437 19.2499 19.25C19.2499 19.7563 18.8396 20.1667 18.3333 20.1667H11.9166C11.4103 20.1667 10.9999 19.7563 10.9999 19.25Z" fill="#6A6A6A"/></g><defs><clipPath id="clip0_423_204"><rect width="22" height="22" fill="white"/></clipPath></defs></svg>';
  }
  function svgDelete() {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"><g clip-path="url(#clip0_423_195)"><path d="M5.50004 6.41667V16.5C5.50004 17.5125 6.32085 18.3333 7.33337 18.3333H14.6667C15.6793 18.3333 16.5 17.5125 16.5 16.5V6.41667M5.50004 6.41667H4.58337M5.50004 6.41667H7.33337M16.5 6.41667H17.4167M16.5 6.41667H14.6667M7.33337 6.41667V4.58333C7.33337 3.57081 8.15418 2.75 9.16671 2.75H12.8334C13.8459 2.75 14.6667 3.57081 14.6667 4.58333V6.41667M7.33337 6.41667H14.6667M9.16671 10.0833V14.6667M12.8334 10.0833V14.6667" stroke="#6A6A6A" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_423_195"><rect width="22" height="22" fill="white"/></clipPath></defs></svg>';
  }
  */
  function svgChevron(up) {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="' + (up ? 'M5 15l7-7 7 7' : 'M19 9l-7 7-7-7') + '"/></svg>';
  }

  // ── Refresh cart drawer (theme-agnostic) ──────────────────────────────────
  function refreshCartDrawer() {
    var events = ['cart:refresh', 'cart:updated', 'cart-drawer:refresh', 'theme:cart:updated'];
    events.forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });

    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) {
      if (typeof drawerEl.refresh === 'function')        drawerEl.refresh();
      if (typeof drawerEl.renderContents === 'function') drawerEl.renderContents();
    }

    var sectionId = (drawerEl && drawerEl.dataset.sectionId) || 'cart-drawer';
    fetch('/?sections=' + sectionId)
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections[sectionId];
        if (!html) return;
        var parsed   = new DOMParser().parseFromString(html, 'text/html');
        var newInner = parsed.querySelector('#shopify-section-' + sectionId);
        var oldInner = document.getElementById('shopify-section-' + sectionId);
        if (newInner && oldInner) oldInner.innerHTML = newInner.innerHTML;
        var newItems = parsed.querySelector('.cart-drawer__items, .cart__items, [data-cart-items]');
        var oldItems = document.querySelector('.cart-drawer__items, .cart__items, [data-cart-items]');
        if (newItems && oldItems) oldItems.innerHTML = newItems.innerHTML;
      })
      .catch(function () {
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));
      });
  }

  // ── Open <quick-buy-modal> for a product ─────────────────────────────────
  // Commented out — edit button removed from cart nudge.
  /* function openQuickAdd(item) {
    var productHandle = item.handle || item.url.split('/products/')[1].split('?')[0];
    var lineKey       = item.key;
    var origVariantId = String(item.variant_id);

    log('openQuickAdd() called for:', productHandle, '| lineKey:', lineKey, '| variantId:', origVariantId);

    var allModals = document.querySelectorAll('quick-buy-modal');
    var modal = null;
    for (var i = 0; i < allModals.length; i++) {
      var attr = allModals[i].getAttribute('handle') || '';
      if (attr.split('?')[0] === productHandle) { modal = allModals[i]; break; }
    }
    if (!modal) {
      for (var j = 0; j < allModals.length; j++) {
        if ((allModals[j].id || '').indexOf(productHandle) !== -1) {
          modal = allModals[j]; break;
        }
      }
    }
    if (!modal) {
      log('openQuickAdd: no existing modal found → creating dynamic modal');
      modal = document.createElement('quick-buy-modal');
      modal.id        = 'cn-dynamic-quick-buy';
      modal.className = 'quick-buy-modal modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('handle', productHandle + '?variant=' + origVariantId);
      document.body.appendChild(modal);
    } else {
      log('openQuickAdd: found existing modal #' + modal.id);
    }

    modal.setAttribute('handle', productHandle + '?variant=' + origVariantId);

    var _realFetch = window.fetch;
    var _done      = false;

    window.fetch = function patchedFetch(url, opts) {
      var urlStr = typeof url === 'string' ? url : (url && url.url) || '';

      if (urlStr.indexOf('cart/add') === -1) {
        return _realFetch.apply(this, arguments);
      }
      if (_done) return _realFetch.apply(this, arguments);
      _done = true;
      window.fetch = _realFetch;

      var newVariantId = origVariantId;
      var quantity     = 1;
      try {
        if (opts && opts.body) {
          if (opts.body instanceof FormData) {
            newVariantId = opts.body.get('id') || origVariantId;
            quantity     = parseInt(opts.body.get('quantity') || '1', 10);
          } else {
            var bd = JSON.parse(opts.body);
            newVariantId = String(bd.id || origVariantId);
            quantity     = parseInt(bd.quantity || 1, 10);
          }
        }
      } catch(e) {}

      log('openQuickAdd: edit intercepted → swapping variant', origVariantId, '→', newVariantId, 'qty:', quantity);

      return _realFetch(Shopify.routes.root + 'cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: lineKey, quantity: 0 })
      })
      .then(function() {
        return _realFetch(Shopify.routes.root + 'cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ id: parseInt(newVariantId, 10), quantity: quantity })
        });
      })
      .then(function() {
        if (typeof modal.hide === 'function') modal.hide();
        return _realFetch(Shopify.routes.root + 'cart.js');
      })
      .then(function(r) { return r.json(); })
      .then(function(updatedCart) {
        log('openQuickAdd: edit complete → refreshing nudge (NOT marking first_add)');
        refreshNudge(updatedCart);
        refreshCartDrawer();
      })
      .catch(function(err) {
        window.fetch = _realFetch;
        log('openQuickAdd: edit error:', err);
      });
    };

    modal.addEventListener('dialog:after-hide', function cleanup() {
      if (!_done) { window.fetch = _realFetch; }
      modal.removeEventListener('dialog:after-hide', cleanup);
    }, { once: true });

    if (typeof modal.show === 'function') {
      log('openQuickAdd: calling modal.show()');
      modal.show();
    } else {
      var btn = document.querySelector('[aria-controls="' + modal.id + '"]');
      if (btn) { log('openQuickAdd: clicking aria-controls button'); btn.click(); }
      else log('openQuickAdd: WARNING — no show() method and no aria-controls button found');
    }
  } */

  // ── Build a single item row ───────────────────────────────────────────────
  function buildItemRow(item) {
    var row = document.createElement('div');
    row.className = 'cn-item';

    if (item.image) {
      var img = document.createElement('img');
      img.className = 'cn-img';
      img.src       = item.image;
      img.alt       = item.product_title;
      img.loading   = 'lazy';
      row.appendChild(img);
    } else {
      var ph = document.createElement('div');
      ph.className = 'cn-img-ph';
      row.appendChild(ph);
    }

    var info = document.createElement('div');
    info.className = 'cn-info';

    var nameEl = document.createElement('p');
    nameEl.className   = 'cn-name';
    nameEl.textContent = item.product_title;
    info.appendChild(nameEl);

    var priceEl = document.createElement('p');
    priceEl.className = 'cn-price';
    priceEl.innerHTML = '<strong class="cn-final-price">' + formatMoney(item.final_price) + '</strong>';
    info.appendChild(priceEl);

    if (item.variant_title && item.variant_title !== 'Default Title') {
      var variantEl = document.createElement('p');
      variantEl.className   = 'cn-variant';
      variantEl.textContent = 'Size - ' + item.variant_title;
      info.appendChild(variantEl);
    }

    var productHandle = item.handle || (item.url && item.url.split('/products/')[1] && item.url.split('/products/')[1].split('?')[0]);
    if (productHandle) {
      fetch(Shopify.routes.root + 'products/' + productHandle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          var variants = product.variants || [];
          for (var i = 0; i < variants.length; i++) {
            if (String(variants[i].id) === String(item.variant_id)) {
              var compareAt      = variants[i].compare_at_price;
              var compareAtCents = compareAt ? parseInt(compareAt, 10) : 0;
              if (compareAtCents && compareAtCents > item.final_price) {
                priceEl.innerHTML =
                  '<s class="cn-compare-price">' + formatMoney(compareAtCents) + '</s>' +
                  ' <strong class="cn-final-price">' + formatMoney(item.final_price) + '</strong>';
              } else {
                priceEl.innerHTML =
                  '<strong class="cn-final-price">' + formatMoney(item.final_price) + '</strong>';
              }
              break;
            }
          }
        })
        .catch(function() {});
    }
    row.appendChild(info);

    /* Edit and delete buttons removed per design decision.
    var actions = document.createElement('div');
    actions.className = 'cn-item-actions';

    var editBtn = document.createElement('button');
    editBtn.className = 'cn-action-btn cn-edit-btn';
    editBtn.setAttribute('aria-label', 'Edit item');
    editBtn.innerHTML = svgEdit();
    editBtn.addEventListener('click', function () { openQuickAdd(item); });

    var deleteBtn = document.createElement('button');
    deleteBtn.className = 'cn-action-btn cn-delete-btn';
    deleteBtn.setAttribute('aria-label', 'Remove item');
    deleteBtn.innerHTML = svgDelete();
    deleteBtn.addEventListener('click', function () {
      log('Delete clicked for item:', item.product_title, '| key:', item.key);
      deleteBtn.disabled      = true;
      deleteBtn.style.opacity = '0.5';
      fetch('/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: item.key, quantity: 0 })
      })
      .then(function (r) { return r.json(); })
      .then(function (updated) {
        log('Delete success → cart item_count now:', updated.item_count);
        refreshCartDrawer();
        if (updated.item_count === 0) {
          log('Cart empty after delete → dismissing nudge');
          dismiss();
        } else {
          log('Cart still has items → refreshing nudge');
          refreshNudge(updated);
        }
      })
      .catch(function (err) {
        log('Delete error:', err);
        deleteBtn.disabled      = false;
        deleteBtn.style.opacity = '1';
      });
    });

    actions.appendChild(editBtn);
    actions.appendChild(deleteBtn);
    row.appendChild(actions);
    */

    return row;
  }

  // ── Build full nudge ──────────────────────────────────────────────────────
  function buildNudge(cart) {
    var firstItem  = cart.items[0];
    var extraItems = cart.items.slice(1);
    var extraCount = extraItems.length;

    log('buildNudge() → item_count:', cart.item_count, '| total_price:', formatMoney(cart.total_price));

    var overlay = document.createElement('div');
    overlay.className = 'cn-overlay';
    overlay.id        = 'cartNudgeOverlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-label', 'Cart reminder');

    var card = document.createElement('div');
    card.className = 'cn-card';

    var header = document.createElement('div');
    header.className = 'cn-header';
    var titleEl = document.createElement('p');
    titleEl.className   = 'cn-title';
    titleEl.textContent = 'You have ' + cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '') + ' in your cart';
    var closeBtn = document.createElement('button');
    closeBtn.className = 'cn-close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#282828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    header.appendChild(titleEl);
    header.appendChild(closeBtn);

    var body = document.createElement('div');
    body.className = 'cn-body';

    var itemsWrapper = document.createElement('div');
    itemsWrapper.className = 'cn-items-wrapper';
    itemsWrapper.appendChild(buildItemRow(firstItem));

    if (extraCount > 0) {
      var extraList = document.createElement('div');
      extraList.className = 'cn-extra-items';
      extraList.setAttribute('aria-hidden', 'true');
      var extraInner = document.createElement('div');
      extraItems.forEach(function (it) {
        var row = buildItemRow(it);
        row.classList.add('cn-item--extra');
        extraInner.appendChild(row);
      });
      extraList.appendChild(extraInner);
      itemsWrapper.appendChild(extraList);
    }
    
    body.appendChild(itemsWrapper);

    if (extraCount > 0) {
      var moreBtn = document.createElement('button');
      moreBtn.className = 'cn-more';
      moreBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      moreBtn.innerHTML = buildMoreLabel(extraCount, isExpanded);

      if (isExpanded) {
        extraList.classList.add('cn-extra-items--open');
        extraList.setAttribute('aria-hidden', 'false');
      }

      moreBtn.addEventListener('click', function () {
        isExpanded = !isExpanded;
        extraList.classList.toggle('cn-extra-items--open', isExpanded);
        extraList.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');
        moreBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        moreBtn.innerHTML = buildMoreLabel(extraCount, isExpanded);
      });

      body.appendChild(moreBtn);
    }

    var footer = document.createElement('div');
    footer.className = 'cn-footer';

    var totalRow = document.createElement('div');
    totalRow.className = 'cn-total';
    var totalLabel = document.createElement('span');
    totalLabel.className   = 'cn-total-label';
    totalLabel.textContent = 'Subtotal:';
    var totalPrice = document.createElement('span');
    totalPrice.className   = 'cn-total-price';
    totalPrice.textContent = formatMoney(cart.original_total_price);
    totalRow.appendChild(totalLabel);
    totalRow.appendChild(totalPrice);

    var checkoutBtn = document.createElement('button');
    checkoutBtn.type      = 'button';
    checkoutBtn.className = 'cn-btn';
    checkoutBtn.innerHTML = '<span>VIEW CART</span>';
    checkoutBtn.addEventListener('click', function () {
      log('View Cart button clicked → dismissing nudge and opening cart drawer');
      dismiss();
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      }, 0);
    });

    footer.appendChild(totalRow);
    footer.appendChild(checkoutBtn);

    card.appendChild(header);
    card.appendChild(body);
    card.appendChild(footer);
    overlay.appendChild(card);

    return { overlay: overlay, closeBtn: closeBtn };
  }

  function buildMoreLabel(count, expanded) {
    return expanded
      ? svgChevron(true)  + ' <span>Show less</span>'
      : svgChevron(false) + ' <span>+' + count + ' More Item' + (count > 1 ? 's' : '') + '</span>';
  }

  // ── Refresh nudge in-place (used by edit/delete flows) ───────────────────
  function refreshNudge(cart) {
    log('refreshNudge() called → item_count:', cart.item_count);
    var fresh = buildNudge(cart);

    var oldBackdrop = document.getElementById('cartNudgeBackdrop');
    if (oldBackdrop) oldBackdrop.parentNode.removeChild(oldBackdrop);

    var backdrop = createBackdrop();

    if (overlayRef && overlayRef.parentNode) {
      overlayRef.parentNode.replaceChild(fresh.overlay, overlayRef);
    } else {
      document.body.appendChild(fresh.overlay);
    }

    overlayRef = fresh.overlay;
    bindEvents(overlayRef, fresh.closeBtn, backdrop);
  }

  // ── Backdrop ──────────────────────────────────────────────────────────────
  function createBackdrop() {
    var bd = document.getElementById('cartNudgeBackdrop');
    if (bd) bd.parentNode.removeChild(bd);

    bd = document.createElement('div');
    bd.id = 'cartNudgeBackdrop';

    bd.setAttribute('style', [
      'position:fixed',
      'top:0',
      'left:0',
      'right:0',
      'bottom:0',
      'background:rgba(0,0,0,0.6)',
      'z-index:29',
      'margin:0',
      'padding:0',
      'border:none',
      'opacity:0',
      'transition:opacity 0.3s ease',
      'pointer-events:all'
    ].join('!important;') + '!important');

    document.documentElement.appendChild(bd);

    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        bd.style.setProperty('opacity', '1', 'important');
      });
    });

    return bd;
  }

  function lockScroll()   {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }
  function unlockScroll() {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  // ── Dismiss ───────────────────────────────────────────────────────────────
  function dismiss() {
    if (!overlayRef) {
      log('dismiss() called but overlayRef is null — nothing to dismiss');
      return;
    }
    log('dismiss() → marking nudge closed and removing overlay');
    dumpSessionState('before dismiss');
    markNudgeClosed();
    overlayRef.classList.add('cn--hide');
    unlockScroll();
    var el = overlayRef;
    var bd = document.getElementById('cartNudgeBackdrop');
    if (bd) bd.style.setProperty('opacity', '0', 'important');
    setTimeout(function () {
      if (el.parentNode) el.parentNode.removeChild(el);
      var bd2 = document.getElementById('cartNudgeBackdrop');
      if (bd2 && bd2.parentNode) bd2.parentNode.removeChild(bd2);
      log('dismiss() animation complete → overlay removed from DOM');
      dumpSessionState('after dismiss');
    }, 300);
    overlayRef = null;
  }

  // ── Bind close + drawer events ────────────────────────────────────────────
  function bindEvents(_overlay, closeBtn, _backdrop) {
    closeBtn.addEventListener('click', function () {
      log('Close button clicked → dismiss()');
      dismiss();
    });
    lockScroll();
    ['cart-drawer:open', 'cartDrawer:open', 'cart:open'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        log('Cart drawer open event fired (' + evt + ') → dismiss()');
        dismiss();
      }, { once: true });
    });
  }

  // ── Homepage-only update event listeners ─────────────────────────────────
  function listenForUpdateEvents() {
    var updateEvents = ['cart:updated', 'cart-drawer:refreshed', 'theme:cart:updated'];
    updateEvents.forEach(function (evt) {
      document.addEventListener(evt, function () {
        log('Update event fired:', evt, '| overlayRef active:', !!overlayRef);
        if (overlayRef) fetchAndRefreshExisting();
      });
    });
    log('Homepage update-event listeners registered for:', updateEvents.join(', '));
  }

  // Refresh the nudge ONLY if it is already visible (used for non-add updates).
  function fetchAndRefreshExisting() {
    log('fetchAndRefreshExisting() called');
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        log('fetchAndRefreshExisting → item_count:', cart.item_count, '| overlayRef active:', !!overlayRef);
        if (cart.item_count === 0) { log('  ↳ Cart is empty → dismiss()'); dismiss(); return; }
        if (!overlayRef) { log('  ↳ Nudge not open → skipping refresh (will not open new nudge)'); return; }
        refreshNudge(cart);
      })
      .catch(function (err) { log('fetchAndRefreshExisting error:', err); });
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  function init() {
    listenForUpdateEvents();

    log('init() running → checking shouldShowNudge()');
    dumpSessionState('at init()');

    if (!shouldShowNudge()) {
      log('init() → shouldShowNudge() returned false → NUDGE WILL NOT SHOW');
      return;
    }

    if (document.documentElement.classList.contains('js-drawer-open')) {
      log('init() → cart drawer is already open → NUDGE WILL NOT SHOW');
      return;
    }

    log('init() → shouldShowNudge() returned true → fetching cart...');

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        log('init() cart fetch → item_count:', cart.item_count, '| total_price:', formatMoney(cart.total_price));
        if (!cart || cart.item_count === 0) {
          log('init() → cart is empty → NUDGE WILL NOT SHOW');
          return;
        }
        log('init() → all conditions met → SHOWING NUDGE');
        log('  ↳ Items in cart:', cart.items.map(function(i){ return i.product_title + ' (qty:' + i.quantity + ')'; }).join(', '));
        dumpSessionState('just before showing nudge');
        var result   = buildNudge(cart);
        var backdrop = createBackdrop();
        overlayRef   = result.overlay;
        document.body.appendChild(overlayRef);
        bindEvents(overlayRef, result.closeBtn, backdrop);
      })
      .catch(function (err) { log('init() cart fetch error:', err); });
  }

  setTimeout(function () {
    log('Timer fired after', NUDGE_DELAY_MS + 'ms → checking readyState:', document.readyState);
    if (document.readyState === 'loading') {
      log('DOM still loading → waiting for DOMContentLoaded');
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }, NUDGE_DELAY_MS);

})();
